import React from 'react'
import classNames from 'classnames'
import './badge.scss'

export type BadgeVariant = 'success' | 'error' | 'warning' | 'info' | 'neutral'
export type BadgeSize = 'small' | 'medium' | 'large'

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
    label?: string
    variant?: BadgeVariant
    size?: BadgeSize
    loading?: boolean
}

export const Badge = ({
    children,
    className,
    label,
    variant = 'neutral',
    size = 'medium',
    loading,
    ...props
}: BadgeProps) => (
    <span className={classNames('badge', className, variant, size, { loading })} title={label} {...props}>
        {loading ? <>&nbsp;</> : label ?? children}
    </span>
)

export default Badge
